import React, { FunctionComponent } from 'react'
import { Accordion, ContentCard } from '../../../components/integration-builder'
import { AcceptCards, AcceptPayments } from '../../../components/icons'

import { Tooltip, Row, Col } from '@paypalcorp/pp-react'
import styles from '../integration-builder.module.css'
import { useApplicationContext } from '../../../provider'

const TITLES = {
  testA: {
    standardName: 'PayPal Payments',
    standardAllows: 'allows you to offer a variety of payment options:',
    advanceName: 'Card processing and preferred ways to pay',
    advanceAllows:
      'allows you to offer the same PayPal Payments options as well as:',
  },
  testB: {
    standardName: 'Standard Checkout',
    standardAllows: 'allows you to offer a variety of payment options:',
    advanceName: 'Advanced Checkout',
    advanceAllows:
      'allows you to accept all of the Standard Checkout payment types as well as:',
  },
}

const StandardTooltip = (
  <Tooltip
    name="tooltip-for-standard"
    description="PayPal payments are presented with PayPal-branded buttons and payment is processed through the PayPal back-end."
    windowId="window1"
  />
)
const AdvanceTooltip = (
  <Tooltip
    name="tooltip-for-advance"
    description="Requires a merchant account and approval for hosted checkout functionality."
    windowId="window1"
  />
)

const KBYC: FunctionComponent = () => {
  const { experiments } = useApplicationContext()

  const treatment = experiments.integrationBuilderKBYC?.startsWith('Trmt_')
    ? 'testA'
    : 'testB'
  const cardStandardName = TITLES[treatment].standardName
  const cardStandardAllows = TITLES[treatment].standardAllows
  const cardAdvanceName = TITLES[treatment].advanceName
  const cardAdvanceAllows = TITLES[treatment].advanceAllows

  return (
    <div className={styles.checkout_simulator__card_wrapper}>
      <Accordion
        color="primary"
        heading={
          <h1 className={styles.checkout_simulator__head_title}>
            Know before you code
          </h1>
        }
        content={
          <div className={styles.checkout_simulator__cards_wrapper}>
            <Row>
              <Col sm={12} md={6}>
                <ContentCard
                  icon={<AcceptPayments width="36" height="36" />}
                  badgeType="feature"
                  badgeText="Standard"
                  content={
                    <>
                      <span className={styles.checkout_simulator__card_title}>
                        {cardStandardName}
                      </span>
                      <span className={styles.integration_builder__tooltip}>
                        {StandardTooltip}
                      </span>
                      <span className={styles.checkout_simulator__card_title}>
                        {cardStandardAllows}
                      </span>
                      <ul className={styles.checkout_simulator__card_content}>
                        <li>PayPal</li>
                        <li>Pay Later</li>
                        <li>Venmo</li>
                        <li>
                          Debit and Credit through a PayPal-managed guest
                          checkout
                        </li>
                      </ul>
                    </>
                  }
                />
              </Col>
              <Col sm={12} md={6}>
                <ContentCard
                  icon={<AcceptCards width="44" height="28" />}
                  badgeType="feature"
                  badgeText="Advanced"
                  content={
                    <>
                      <span className={styles.checkout_simulator__card_title}>
                        {cardAdvanceName}
                      </span>
                      <span className={styles.integration_builder__tooltip}>
                        {AdvanceTooltip}
                      </span>
                      <span className={styles.checkout_simulator__card_title}>
                        {cardAdvanceAllows}
                      </span>
                      <ul className={styles.checkout_simulator__card_content}>
                        <li>Direct Debit and Credit card processing</li>
                        <li>Customizable Payment Protection</li>
                        <li>
                          Unbranded checkout, with customizable buttons and form
                          fields
                        </li>
                        <li>Region-specific alternative payments methods</li>
                      </ul>
                    </>
                  }
                />
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  )
}

export default KBYC
